// Table.tsx
import React from "react";

import TBody from "./TBody";
import TD from "./TD";
import TH from "./TH";
import THead from "./THead";
import TR from "./TR";
import { cn } from "helpers/classNames";

interface Props extends React.HTMLAttributes<HTMLTableElement> {}

interface Childs {
  TR: typeof TR;
  TD: typeof TD;
  TH: typeof TH;
  TBody: typeof TBody;
  THead: typeof THead;
}

const BasicTable: React.FC<Props> & Childs = ({ className, ...rest }) => {
  return (
    <div
      className={cn("border-gray-30 border shadow sm:rounded-lg", className)}
    >
      <table {...rest} className={"min-w-full divide-y divide-gray-300"} />
    </div>
  );
};

BasicTable.TR = TR;
BasicTable.TD = TD;
BasicTable.TH = TH;
BasicTable.TBody = TBody;
BasicTable.THead = THead;

export default BasicTable;
